import { createContext } from "react";
import type { ClientFeatureFlags } from "./types";

// Keep context identity independent of the provider's Fast Refresh boundary.
export const FeatureFlagsContext = createContext<{
  flags: ClientFeatureFlags;
  isPending: boolean;
  isError: boolean;
} | null>(null);
